<div class="container qr-container">
  <div class="col d-flex align-items-center justify-content-center">
    <img class="img-fluid" alt="QR-code" [attr.src]="imageURL">
  </div>
</div>
